export default "__VITE_ASSET__313320e8__"